<template>
  <div class="login">
    <div class="login__container">
      <h1 class="login__title">账号登录</h1>
      <el-form
        ref="ruleForm"
        class="login__ruleForm"
        :model="form"
        :rules="rules"
        @submit.native.prevent
      >
        <el-form-item prop="account">
          <el-input
            v-model="form.account"
            placeholder="请输入账号"
            maxlength="64"
            autocomplete="username"
            @keyup.enter.native="handlerSubmit('ruleForm')"
          />
        </el-form-item>
        <el-form-item prop="secret">
          <el-input
            v-model="form.secret"
            show-password
            placeholder="请输入密码"
            maxlength="64"
            autocomplete="current-password"
            @keyup.enter.native="handlerSubmit('ruleForm')"
          />
        </el-form-item>
      </el-form>
      <div class="login__remember">
        <span></span>
        <el-checkbox v-model="isRemember">记住此账号</el-checkbox>
      </div>
      <div class="login__submit fn-text-center">
        <el-button
          type="primary"
          :loading="submitting"
          @click="handlerSubmit('ruleForm')"
        >
          登录
        </el-button>
      </div>
    </div>

    <div class="login__footer">
      <p>PPT 大屏 · 运营管理后台</p>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { login as loginApi } from "@/api/auth";

function encodeRemember(str) {
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch (e) {
    return "";
  }
}

function decodeRemember(str) {
  try {
    return decodeURIComponent(escape(atob(str)));
  } catch (e) {
    return "";
  }
}

export default {
  name: "adminLogin",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => ({
      required: true,
      message,
      trigger
    });
    const { isRemember, account, secret } = this.judgeRemember();
    return {
      submitting: false,
      isRemember,
      form: {
        account,
        secret
      },
      rules: {
        account: [isEmpty("请输入账号")],
        secret: [
          isEmpty("请输入密码"),
          {
            validator(rule, value, callback) {
              if (!/.{8,64}/.test(value || "")) {
                return callback(new Error("请输入长度为 8～64 的密码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    judgeRemember() {
      let isRemember;
      let account = "";
      let secret = "";
      if (this.$cookies.get("_user_back_account")) {
        isRemember = true;
        account = decodeRemember(this.$cookies.get("_user_back_account"));
        secret = decodeRemember(this.$cookies.get("_user_back_pwd"));
      } else {
        isRemember = false;
      }
      return { isRemember, account, secret };
    },
    addPwdCookie({ account, secret }) {
      if (this.isRemember) {
        this.$cookies.set("_user_back_account", encodeRemember(account), {
          path: "/",
          maxAge: 60 * 60 * 24 * 7
        });
        this.$cookies.set("_user_back_pwd", encodeRemember(secret), {
          path: "/",
          maxAge: 60 * 60 * 24 * 7
        });
      } else {
        this.$cookies.remove("_user_back_account");
        this.$cookies.remove("_user_back_pwd");
      }
    },
    handlerSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadCommit();
        }
      });
    },
    errMsg(err, fallback) {
      const d = err && err.response && err.response.data;
      if (d && typeof d.message === "string") {
        return d.message;
      }
      if (d && typeof d === "string") {
        return d;
      }
      if (err && err.message) {
        return err.message;
      }
      return fallback;
    },
    async loadCommit() {
      this.submitting = true;
      try {
        const res = await loginApi({
          userName: this.form.account.trim(),
          password: this.form.secret
        });
        if (res.code !== 0 || !res.token) {
          Message.error(res.message || "登录失败");
          return;
        }
        Message.success(res.message || "登录成功");
        this.$cookies.set("token", res.token, {
          path: "/",
          maxAge: 60 * 60 * 24 * 3
        });
        this.addPwdCookie(this.form);
        this.setLoginDateCookie();
        const redir = this.$route.query.redirect;
        const safe =
          typeof redir === "string" &&
          redir.startsWith("/admin") &&
          redir !== "/admin/login";
        this.$router.replace(safe ? redir : "/admin");
      } catch (err) {
        Message.error(this.errMsg(err, "登录失败"));
      } finally {
        this.submitting = false;
      }
    },
    setLoginDateCookie() {
      const d = new Date();
      const time = `${d.getFullYear()}年${d.getMonth() +
        1}月${d.getDate()}日 ${d.getHours()}时${d.getMinutes()}分`;
      this.$cookies.set("loginBackDate", time, { path: "/" });
    }
  }
};
</script>

<style lang="less" scoped>
@login-accent: #409eff;

.login {
  position: relative;
  height: 100vh;
  background: url("~@/assets/images/login_bg.png") center center;
  background-size: cover;

  .login__container {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 450px;
    min-height: 520px;
    padding: 0 75px 40px;
    border-radius: 10px;
    color: #ffffff;
    background: rgba(7, 13, 22, 0.72);
    transform: translate(-50%, -50%);

    .login__title {
      padding: 49px 0 40px;
      font-size: 30px;
      font-weight: 500;
      line-height: 30px;
      text-align: center;
      letter-spacing: 1px;
    }

    /deep/ .login__ruleForm {
      .el-form-item {
        margin-bottom: 26px;
        .el-input__inner {
          height: 42px;
          border: none;
          line-height: 42px;
          color: #ffffff;
          border-radius: 6px;
          background-color: rgba(242, 242, 242, 0.2);
        }
        .el-form-item__error {
          color: #f56c6c;
        }
        .el-input .el-input__clear {
          color: #999999;
        }
      }

      input::placeholder {
        font-size: 14px;
        color: #999999;
      }
    }
    .login__remember {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      /deep/ .el-checkbox {
        color: #999999;
        .el-checkbox__inner {
          border: 1px solid #e6e6e6;
          box-shadow: 0px 0px 3px 0px rgba(51, 51, 51, 0.71);
          background-color: transparent;
          &:hover {
            border-color: @login-accent;
          }
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: @login-accent;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          border-color: @login-accent;
          background-color: @login-accent;
        }
        .el-checkbox__label {
          line-height: 14px;
          font-size: 12px;
        }
      }
    }
    .login__submit {
      margin-top: 56px;
      .el-button {
        width: 300px;
        border-radius: 6px;
      }
    }
  }

  .login__footer {
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    font-size: 14px;
    color: #999999;
    line-height: 30px;
    text-align: center;
  }
}
</style>
